import { useState,useEffect } from 'react'
import './styles/UsersAdmin.css'
import Action from '../Action'
import { useFetch } from '../../hooks/useFetch'
import { useFetchPost } from '../../hooks/useFetchPost'
import Selector from '../Selector'
import LoadAdding from '../LoadAdding'
import LoadSimple from '../LoadSimple'
import UserList from './UserList'
import { capitalizeFirstLetter } from '../../utils/utils'
import { lang } from '../generales/traduction'
const TableUsers=(props)=>{
    return (
        
<div className='cont-table-portafolio'>
<div className={"head-table-portafolio"+props.mode}>
<div className="compact-head-table-portafolio">
                                        
                                        <div className='field-head-table-users field-nombre'>
                                            {capitalizeFirstLetter(lang[props.languaje]['nombre'])}
                                        </div>
                                        <div className='field-head-table-users field-correo'>
                                        {capitalizeFirstLetter(lang[props.languaje]['correo'])}
                                        </div>
                                        <div className='field-head-table-users field-rol' style={{borderRight: '1px solid rgba(240, 248, 255, 0.473)'}}>
                                            Rol
                                        </div>
                                        <div className='field-head-table-users field-correo' style={{borderRight: '1px solid rgba(240, 248, 255, 0.473)'}}>
                                        {capitalizeFirstLetter(lang[props.languaje]['grupos'])}
                                        </div>
                                        <div className='field-head-table-users field-acciones'>
                                        {capitalizeFirstLetter(lang[props.languaje]['acciones'])}
                                        </div>
                                        </div>
                                    </div>
                                    <div className='body-table-portafolio'>
                                        {
                                            ( props.registerIsValid)?<div className='cont-load-user-list'><LoadSimple></LoadSimple></div>:
                                            <UserList pageActual={props.pageActual} limitList={props.limitList} dataList={props.dataList} setDataUsers={props.setDataUsers} dataUsers={props.dataUsers} languaje={props.languaje} mode={props.mode} server={props.server} handleChangEdit={props.handleChangEdit} setData={props.setData} setLoading={props.setLoading} setError={props.setError}></UserList>
                                        
                                          }
                                        
                                    </div>
                                </div>
    )
}

export default TableUsers